<div class="row">
  <div class="col-md-*">
    
    <h3 class="t-a-center m-b-0 m-t-15-bp-d">

      <button kendoButton *ngIf="!patientDetails" themeColor="primary" (click)="applyProfile()" class="fl-r">
        {{ patientDetails ? 'Змінити персональні дані' : 'Мої записи' }}
      </button>

      Запис пацієнта на прийом з {{ minDate | date : 'dd.MM.yyyy' }} по {{ maxDate | date : 'dd.MM.yyyy' }}
    </h3>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <h4 class="t-a-center m-b-0 p-5-0 bg-c-E7EBEE m-t-15-bp-d">
      Перелік напрямків медичної допомоги
    </h4>

    <medical-appointments-list (dataSelected)="setMedicalAppointment($event)"></medical-appointments-list>
  </div>

  <div class="col-md-6">

    <div class="row">
      <div class="col-md-*">

        <h4 class="t-a-center m-b-0 p-5-0 bg-c-E7EBEE m-t-15-bp-d">
          Дата та час прийомів
        </h4>

        <!-- astra-based schedules -->
        <ng-container *ngIf="medApp?.scheduleId">
          <div class="row">

            <medical-appointment-queues-period-list2
                  [queues]="medAppsQueues2$ | async" 
                  [isloading]="medAppsQueuesAreLoading"
                  (queueSelected)="setQueue2($event)"
            >
            </medical-appointment-queues-period-list2>

          </div>

          <div class="pt-3">
            <patient-details [patient]="patientDetails$ | async" (appIsDeleted)="appointmentDeleted($event)"></patient-details>
          </div>
        </ng-container>

        <!-- external schedules -->
        <div class="t-a-center f-s-18 f-w-600" *ngIf="!medApp?.scheduleId && medApp?.url">

          <br /><br />
          Шановний відвідувач!

          <br /><br />
          Ознайомитись з графіком прийому обраного лікаря та записатись на прийом можна за посиланням нижче

          <br /><br />
          <a href="{{ medApp?.url }}" target="_blank" class="k-button k-button-md k-rounded-md k-button-solid-primary k-button-solid"> 
            Записатись на прийом 
          </a>

        </div>


      </div>
    </div>


  </div>
</div>


<patient-appointment-create *ngIf="medAppQueue" 
  [patientDetails]="patientDetails"
  [selectedAppointment]="medAppQueue" 
  (appointmentAdded)="appointmentAdded($event)"
  (appointmentCanceled)="appointmentCanceled()"
>
</patient-appointment-create>

<patient-edit *ngIf="editPatientDetails" 
  [patientDetails]="editPatientDetails"
  (profileSaved)="profileSaved($event)">
</patient-edit>

<kendo-dialog-alert *ngIf="reservedAlert" 
  [model]="reservedAlert" 
  (closing)="reservedAlert = null;">
</kendo-dialog-alert>